import React from 'react'
import { FarmerSideBar } from '../components'
import { useAuthentication } from '../../application/hooks';

function FarmerDashboardLayout({children}) {

  useAuthentication();

  return (
    <div className=" flex w-full h-screen">

      <div className="desktopSidebar shadow-lg w-1/6 hidden md:block">
        <FarmerSideBar/>
      </div>

      <div className="dashboard-content flex-1 flex flex-col">

        <div className="dashboard-main-content flex-1 overflow-y-auto p-6">
          {children}
        </div>

      </div>

    </div>
  )
}

export default FarmerDashboardLayout